import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Raven from 'raven-js';

import ExperienceJobContainer from 'src/app/containers/Registration/Experience/ExperienceJobContainer';
import ExperienceEmployerContainer from 'src/app/containers/Registration/Experience/ExperienceEmployerContainer';
import ExperienceDatesComponent from 'src/app/containers/Registration/Experience/ExperienceDatesComponent';
import ExperienceLocationComponent from 'src/app/containers/Registration/Experience/ExperienceLocationComponent';
import {
  experienceFormSend, experienceFormSendError
} from 'src/app/redux/actions/registration/experience/experienceForm';
import {
  experienceJobSetValidationMessage, experienceJobSetVisualization
} from 'src/app/redux/actions/registration/experience/experienceJob';
import {
  experienceDateFromBlur, experienceDateFromSetValidationMessage
} from 'src/app/redux/actions/registration/experience/experienceDateFrom';
import {
  experienceDateToBlur, experienceDateToSetValidationMessage
} from 'src/app/redux/actions/registration/experience/experienceDateTo';
import { LOGIN_REDIRECTION, setStep } from 'src/app/redux/actions/registration/registration';
import 'src/app/containers/Registration/Experience/ExperienceFormContainer.scss';
import { countryBlur } from 'src/app/redux/actions/registration/experience/experienceCountry';
import {
  citySetValidationMessage, citySetVisualization
} from 'src/app/redux/actions/registration/experience/experienceCity';


class ExperienceFormContainer extends React.Component {

  componentWillMount() {
    const { dispatch, userId } = this.props;

    if (!userId) {
      dispatch(setStep(LOGIN_REDIRECTION));
      Raven.captureException(new Error('No userId from account registration obtained'));
    }
  }

  jobInputRef = React.createRef();

  employerInputRef = React.createRef();

  dateFromInputRef = React.createRef();

  dateToInputRef = React.createRef();

  countryRef = React.createRef();

  cityRef = React.createRef();

  sendForm = () => {
    const {
      dispatch,
      stillWorking,
      userId,
      hasWorkExperience,
      job,
      employer,
      dateFrom,
      dateTo,
      countryId,
      city
    } = this.props;


    dispatch(experienceFormSend({
      job,
      employer,
      dateFrom,
      dateTo,
      stillWorking,
      userId,
      hasWorkExperience,
      countryId,
      city
    }));
  };

  submit = (event) => {
    const { sendForm, validateFields } = this;
    const { dispatch, datesValidity, countryId } = this.props;
    const { target } = event;
    event.preventDefault();

    if (target.checkValidity() && datesValidity && countryId) {
      sendForm();
      return;
    }

    dispatch(experienceFormSendError());
    validateFields();
    target.scrollIntoView();
  };

  validateFields = () => {
    const { validateInputs, validateDates, validateCountry } = this;
    validateInputs();
    validateDates();
    validateCountry();
  };

  validateCountry = () => {
    const { dispatch, country, suggestions } = this.props;
    const { countryRef } = this;
    const { validationMessage } = countryRef.current;

    dispatch(countryBlur({ value: country, validationMessage, suggestions }));
  };

  validateInputs = () => {
    const { validate, jobInputRef, cityRef } = this;

    const inputsToValidate = [
      [
        jobInputRef.current, experienceJobSetValidationMessage, experienceJobSetVisualization
      ],
      [
        cityRef.current, citySetValidationMessage, citySetVisualization
      ]
    ];

    inputsToValidate.forEach(validate);
  };

  validateDates = () => {
    const { dispatch, datesValidity } = this.props;
    const { dateFromInputRef, dateToInputRef } = this;

    if (datesValidity) {
      dispatch(experienceDateFromSetValidationMessage(dateFromInputRef.current.element.validationMessage));
      dispatch(experienceDateToSetValidationMessage(dateToInputRef.current.element.validationMessage));
      return;
    }

    const { dateTo, dateFrom } = this.props;

    dispatch(experienceDateFromBlur(
      dateFromInputRef.current.element.validationMessage,
      dateFrom,
      dateTo
    ));
    dispatch(experienceDateToBlur(
      dateToInputRef.current.element.validationMessage,
      dateTo,
      dateFrom
    ));
};

  validate = ([component, setValidationMessage, setVisualization]) => {
    const { dispatch } = this.props;

    dispatch(setValidationMessage(component.validationMessage));
    dispatch(setVisualization(!component.checkValidity()));
  };

  render() {
    const { submit, jobInputRef, employerInputRef, dateFromInputRef, dateToInputRef, countryRef, cityRef } = this;
    const { sending } = this.props;

    return (
      <form styleName="experience-form" onSubmit={ submit } noValidate>

        <div styleName="experience-form__input">
          <ExperienceJobContainer jobInputRef={ jobInputRef }/>
        </div>

        <div styleName="experience-form__input">
          <ExperienceEmployerContainer employerInputRef={ employerInputRef }/>
        </div>

        <ExperienceDatesComponent dateFromInputRef={ dateFromInputRef } dateToInputRef={ dateToInputRef }/>

        <ExperienceLocationComponent countryRef={ countryRef } cityRef={ cityRef } />

        <button type="submit" styleName="experience-form__submit" disabled={ sending } data-test="button-register">
          Zarejestruj się
        </button>

      </form>
    );
  }
}

ExperienceFormContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  stillWorking: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  hasWorkExperience: PropTypes.bool.isRequired,
  job: PropTypes.string.isRequired,
  employer: PropTypes.string.isRequired,
  dateFrom: PropTypes.string.isRequired,
  dateTo: PropTypes.string.isRequired,
  datesValidity: PropTypes.bool.isRequired,
  countryId: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  sending: PropTypes.bool.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.object).isRequired
};

const mapStateToProps = (store) => {
  const validBothDates = store.experienceDateFromReducer.valid && store.experienceDateToReducer.valid;

  return {
    ...store.experienceFormReducer,
    userId: store.registrationReducer.userId,
    job: store.experienceJobReducer.value,
    employer: store.experienceEmployerReducer.value,
    dateFrom: store.experienceDateFromReducer.value,
    dateTo: store.experienceDateToReducer.value,
    countryId: store.experienceCountryReducer.id,
    country: store.experienceCountryReducer.value,
    suggestions: store.experienceCountryReducer.suggestions,
    city: store.experienceCityReducer.value,
    stillWorking: store.experienceDateToReducer.disabled,
    datesValidity: validBothDates || !store.experienceFormReducer.hasWorkExperience
  };
};

export default connect(mapStateToProps)(ExperienceFormContainer);
